import { UPLOAD_SOURCES } from "@cld/upload-widget";
import { asAbsolute } from "root/routes/utils";
import { ROUTES } from "../data/consts";
import Unsplash from "../";
import SummaryPage from "../components/SummaryPage";
import SearchPage from "../components/SearchPage";

const { UNSPLASH } = UPLOAD_SOURCES;

export default [{
	path: asAbsolute(UNSPLASH),
	component: Unsplash,
	routes: [
		{
			path: asAbsolute(UNSPLASH, ROUTES.SUMMARY),
			component: SummaryPage,
		},
		{
			path: asAbsolute(UNSPLASH, ROUTES.SEARCH),
			component: SearchPage,
		}],
}];
